<template>
    <api-delivery-code-card class="w-full" :icon="faInboxIn" :loading="props.response === undefined" :code="props.response?.response_body" :contentType="props.response?.response_content_type" :isTruncated="props.response?.is_truncated">
        <template v-slot:title>
            Response
        </template>
        <template v-slot:metadata>
            <div class="flex flex-col gap-1 text-slate-700 sm:flex-row sm:gap-6">
                <div class="flex flex-wrap gap-1">
                    <strong>Code:</strong> {{ props.response?.response_status_code || '-' }}
                </div>
                <div class="flex flex-wrap gap-1">
                    <strong>Content Type:</strong> {{ props.response?.response_content_type || '-' }}
                </div>
            </div>
        </template>
        <template v-slot:missing-message>
            Response Missing
        </template>
    </api-delivery-code-card>
</template>
<script setup>
import ApiDeliveryCodeCard from './ApiDeliveryCodeCard.vue';
import { faInboxIn } from '@fortawesome/pro-solid-svg-icons';

const props = defineProps({
    response: {
        type: Object,
        required: false,
    }
});

</script>
